import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { BRAND, waLink } from "../../lib/brand";

const links = [
  { href: "#collections", label: "Collections" },
  { href: "#legacy", label: "Legacy" },
  { href: "#craftsmanship", label: "Craftsmanship" },
  { href: "#instagram", label: "Instagram" },
  { href: "#contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-white/80 border-b border-zinc-200"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="logo-link"
          className="flex items-center gap-2 sm:gap-3 min-w-0"
        >
          <img
            src={BRAND.logoUrl}
            alt="Ghisa Ram Khandelwal Saraf"
            className="h-11 w-11 sm:h-14 sm:w-14 object-contain shrink-0"
          />
          <div className="flex flex-col leading-tight min-w-0">
            <span className="font-display text-[12px] sm:text-[15px] tracking-[0.18em] sm:tracking-[0.22em] uppercase text-zinc-900 truncate">
              Ghisa Ram
            </span>
            <span className="text-[8.5px] sm:text-[10px] tracking-[0.25em] sm:tracking-[0.35em] uppercase text-zinc-500 truncate">
              <span className="hidden sm:inline">Khandelwal Saraf · </span>
              <span className="sm:hidden">Khandelwal · </span>Since 1972
            </span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-xs tracking-[0.25em] uppercase text-zinc-700 hover:text-zinc-950 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={waLink()}
            target="_blank"
            rel="noreferrer"
            data-testid="header-whatsapp-btn"
            className="hidden md:inline-flex items-center gap-2 h-10 px-5 text-xs tracking-[0.2em] uppercase border border-zinc-900 text-zinc-900 hover:bg-zinc-900 hover:text-white transition-colors"
          >
            WhatsApp
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-btn"
            className="lg:hidden h-10 w-10 grid place-items-center border border-zinc-300 text-zinc-900"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-white border-t border-zinc-200"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm tracking-[0.25em] uppercase text-zinc-800"
              >
                {l.label}
              </a>
            ))}
            <a
              href={waLink()}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center h-11 px-5 text-xs tracking-[0.2em] uppercase bg-zinc-900 text-white"
            >
              Chat on WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
